export default __webpack_public_path__ + "static/media/cobalt.f2747510.svg";